import './app-config';
import { angularCoreConfigModule } from '../../../shared/app/config/angular-core';
import { loadingBarConfigModule } from '../../../shared/app/config/loading-bar';
import { jsDataConfigModule } from '../../../shared/app/config/js-data';
import { accountServiceConfigModule } from './account-service';
import { authInterceptorConfigModule } from './auth-interceptor';
import { googleAnalyticsConfigModule } from '../../../shared/app/config/ga';
import { appConfigModule } from '../../../shared/app/constants/app-config';

export const configModule = angular.module('Q.config', [
  appConfigModule,
  angularCoreConfigModule,
  loadingBarConfigModule,
  jsDataConfigModule,
  authInterceptorConfigModule,
  accountServiceConfigModule,
  googleAnalyticsConfigModule,
]);
